import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, blueMui, greyMui, rydeColors } from "@ryde/theme";

import { areaWaypointVisual } from "./area-waypoints.utils";

export const AreaWaypointsTemplateWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "area-waypoints-template-wrapper",
  },
)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .area-waypoints-tables {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .area-waypoints-map {
    height: 180px;
    width: 100%;
    border: 1px solid ${greyMui._300};
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 8px;
  }

  .area-waypoints-table-card {
    border: 1px solid ${greyMui._300};
    border-radius: 6px;
    padding: 10px 12px;
    background: ${rydeColors.white};
  }

  .area-waypoints-table-title {
    font-size: 13px;
    font-weight: 600;
    margin: 0 0 8px;
    color: ${greyMui._800};
  }

  .area-waypoints-table {
    width: 100%;
    border-collapse: collapse;
  }

  .area-waypoints-table th,
  .area-waypoints-table td {
    text-align: start;
    padding: 6px 4px;
    font-size: 12px;
    border-bottom: 1px solid ${greyMui._200};
  }

  .area-waypoints-table th {
    color: ${greyMui._600};
    font-weight: 600;
  }

  .area-waypoints-empty {
    font-size: 12px;
    color: ${greyMui._600};
    padding: 6px 0 8px;
  }

  .area-waypoints-edit {
    margin-top: 8px;
  }

  .area-waypoints-name {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .area-waypoints-name-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const AreaWaypointMapPopupStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "area-waypoint-map-popup",
})`
  max-width: 220px;

  .area-waypoint-map-popup-title {
    text-align: start;
    color: ${blueGreyMui._500};
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .area-waypoint-map-popup-address {
    margin-top: 4px;
    font-size: 11px;
    line-height: 1.35;
    color: ${greyMui._700};
    word-break: break-word;
  }
`;

export const AreaWaypointsEditButtonStyled = styled.button.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "area-waypoints-edit-button",
    type: "button",
  },
)`
  line-height: normal;
  font-size: 16px;
  display: flex;
  cursor: pointer;
  color: ${greyMui._700};
  align-items: center;
  gap: 5px;
  border: none;
  background-color: inherit;
  padding: 0;
  &:hover:not(:disabled) {
    color: ${blueMui._700};
  }
  &:disabled {
    color: ${greyMui._500};
    cursor: default;
  }
  svg {
    font-size: 16px;
  }
`;

export const AreaWaypointBadgeStyled = styled.span.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "area-waypoint-badge",
})`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px dashed ${areaWaypointVisual.borderColor};
  color: ${areaWaypointVisual.color};
  background: ${areaWaypointVisual.backgroundColor};
  font-size: 11px;
  font-weight: 700;
`;
